import { FC, SVGProps } from 'react';

const BroadcastScheduleIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  color = '#fff',
  size = 20,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M16.7736 8.62808V6.47212C16.7736 4.14512 15.3238 2.5 12.9944 2.5H6.32961C3.99854 2.5 2.54883 4.14512 2.54883 6.47212V12.8167C2.54883 15.1437 3.99854 16.7887 6.32879 16.7887H8.50259"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.55518 6.22394H16.7693"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.18604 6.22321V2.5M12.138 6.22321V2.5"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.0738 17.4994C15.9387 17.4994 17.4508 15.9873 17.4508 14.1224C17.4508 12.2576 15.9387 10.7454 14.0738 10.7454C12.2089 10.7454 10.6968 12.2576 10.6968 14.1224C10.6968 15.9873 12.2089 17.4994 14.0738 17.4994Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.124 15.0015L14.0562 14.3634V12.9915"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default BroadcastScheduleIcon;
